import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.077 20h-5.077v-16h11v14h-5.077","key":"svg-0"}]]

const IconBrandPagekit = createReactComponent('outline', 'brand-pagekit', 'BrandPagekit', __iconNode);

export default IconBrandPagekit;